import React from "react";
import MyTeamPanel from "../components/MyTeamPanel";

const AdminMyTeamPage = () => {
  return <MyTeamPanel mode="page" />;
};

export default AdminMyTeamPage;
